var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-md-4 px-2"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('app-navigation',{attrs:{"pageTitle":'Admin Portal',"pageTitleSmall":'Admin Portal',"previous":{ path: _vm.$routerHistory.previous().path },"forward":{ path: _vm.$routerHistory.next().path }}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }